import { Link } from 'react-router-dom';

function Header() {
  return (
<header className="bg-gray-900 text-white shadow-lg fixed top-0 left-0 right-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-center">
        <Link to="/" className="flex items-center gap-3">
          <h1 className="text-xl font-bold">
            De Pastoor quiz
          </h1>
        </Link>
      </div>
    </header>
  );
}

export default Header;